import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

interface propsType {
    metaTitle: string | undefined,
    metaDescription: string | undefined,
    metaKeywords: string | undefined,
}

export default function MetaComponent(props: propsType) {

    return (
        <React.Fragment>
            <Helmet>
                {props.metaTitle ?
                    <title>JKOA | {props.metaTitle.replace(/,/g, ' |')}</title>
                    : null}
                {props.metaDescription ?
                    <meta name="description" content={props.metaDescription} />
                    : null}
                {props.metaKeywords ?
                    <meta name="keywords" content={props.metaKeywords} />
                    : null}
            </Helmet>
        </React.Fragment >
    )
}

